import React from "react";

export default function InventoryOrder(props){

    

    return(<>Inventory Order</>)
}